// extracted by mini-css-extract-plugin
export default {"link":"LD-z","disabled":"MD-z"};